import { Card, Text, Title } from 'components';
import React from 'react';

const PrivacyNoticeNavojoa = () => (
  <Card
    style={{
      textAlign: 'justify',
      padding: '2rem 4rem',
    }}
  >
    <Title $accent style={{ textAlign: 'center' }}>
      AVISO DE PRIVACIDAD DEL H. AYUNTAMIENTO DE NAVOJOA
    </Title>
    <br />
    <Text forwardedAs="p">
      El H. Ayuntamiento de Navojoa, Sonora con domicilio en Calle No Reelección y Plaza 5 de Mayo
      s/n, Colonia Centro, C.P. 85800, en Navojoa, Sonora, es el responsable del uso y protección de
      sus datos personales, y al respecto le informa lo siguiente:
    </Text>
    <br />
    <br />
    <Text>
      Los datos personales consisten en la información numérica, alfabética, gráfica, fotográfica,
      acústica, o de cualquier otro tipo, concerniente a una persona física, identificada o
      identificable, relativa a su origen étnico o racial; la que se refiera a sus características
      físicas, morales o emocionales, a su vida afectiva y familiar, información genética, número
      de seguridad social, la huella digital, domicilio, correos electrónicos personales,
      teléfonos particulares, claves informáticas, cibernéticas y códigos personales, así como
      a su patrimonio, incluyendo la contenida en las declaraciones de situación patrimonial; la
      incluida en declaraciones fiscales o derivada de las facultades de comprobación de la
      autoridad fiscal, con las excepciones que señalen las leyes; la concerniente a su ideología
      u opiniones políticas, creencias o convicciones religiosas o filosóficas, los estados de
      salud físicos o mentales, preferencias sexuales, circunstancias y detalles de los delitos
      que afecten el entorno íntimo de las víctimas y, en general,toda aquella información que
      afecte o pueda afectar la intimidad de las personasfísicas
    </Text>
    <br />
    <br />
    <Text>
      Los datos personales que serán sometidos a tratamiento son: nombre, edad, fecha de
      nacimiento, sexo, fotografía, estado civil, domicilio, lugar de nacimiento, números
      telefónicos, correo electrónico, cuentas de redes sociales, firma, RFC, CURP, grado de
      estudios, información laboral, idiomas o dialectos, identificaciones oficiales.
    </Text>
    <br />
    <br />
    <Text>
      Además de los datos personales mencionados anteriormente, utilizaremos los siguientes datos
      personales considerados como sensibles, que requieren de especial protección: firma
      autógrafa, huella digital, toda característica física (color de piel, iris o cabello, señales
      particulares, estatura, peso, complexión, etc.), origen étnico y racial, discapacidades,
      tipo de sangre, datos de salud física y mental (historial y pronósticos clínicos, estado de
      salud actual, exámenes físicos, estado de gravidez, condiciones congénitas,
      recetas médicas), estudios socioeconómicos, datos laborales y patrimoniales tales como
      sueldos o salarios, prestaciones, egresos,seguros de vida, números de cuentas bancarias,
      información sobre sus bienes muebles e inmuebles, información fiscal, historial crediticio
      y reportes del Buró de Crédito.
    </Text>
    <br />
    <br />
    <Text>
      Dichos datos podrán ser recabados, directa o indirectamente por servidores públicos que
      ocupen algún puesto dentro de la Administración Pública Municipal, o bien sus prestadores de
      servicio social, ya sea por medios electrónicos, por escrito y por teléfono. Los datos
      personales que usted proporcione al H. Ayuntamiento de Navojoa, Sonora, serán utilizados
      única y exclusivamente para llevar a cabo los objetivos y atribuciones de este
      Gobierno Municipal, con estricto apego a lo dispuesto por la Ley General de Protección de
      Datos Personales en Posesión de Sujetos Obligados. Se le informa que para la transferencia
      de su información a terceros será requerida su autorización, en tal supuesto, se le buscará
      a efecto de gestionar tal autorización previa justificación de la necesidad o conveniencia
      de la transferencia, bajo el entendido de que no autorizarse no se llevarán a cabo actos de
      transmisión. Sin embargo, se le informa que existe una serie de casos de excepción en los
      cuales no es requerida la autorización del titular de la información para llevar a cabo la
      transferencia, según lo señalan los artículos del 61 al 71 de la Ley General de Protección
      de Datos Personales en Posesión de Sujetos Obligados Usted puede solicitar ante el H.
      Ayuntamiento de Navojoa, Sonora, previa identificación oficial, en cualquier tiempo,
      su Acceso, Rectificación, Cancelación u Oposición de sus datos personales, mediante la
      presentación de solicitud de Protección ante la Unidad de Transparencia del H. Ayuntamiento
      de Navojoa, cuyo titular es el Lic. José Manuel Lagarda Bórquez, en la oficina de la Unidad
      de Transparencia, ubicada en el Palacio Municipal del H. Ayuntamiento de Navojoa,
      Sonora, con domicilio en Calle No Reelección y Plaza 5 de Mayo s/n, Colonia Centro,
      C.P. 85800, Navojoa, Sonora.
    </Text>
    <br />
    <br />
    <Text>
      La solicitud de acceso, rectificación, cancelación u oposición deberá plantearse por escrito y
      presentarse a través de una de las siguientes opciones:
    </Text>
    <br />
    <br />
    <ul>
      <li>
        <Text>
          Personalmente en la oficina de la Unidad de Transparencia ubicada en el Palacio
          Municipal del H. Ayuntamiento de Navojoa, Sonora, con domicilio en Calle No
          Reelección y Plaza 5 de Mayo s/n, Colonia Centro, C.P. 85800
        </Text>
      </li>
      <li>
        <Text>
          Enviarse por correo electrónico a la Unidad de Transparencia:
          {' '}
          <a href="mailto:transparencia@navojoa.gob.mx" target="_blank" rel="noreferrer">
            transparencia@navojoa.gob.mx
          </a>
        </Text>
      </li>
      <li>
        <Text>
          A través del sistema SISAI 2.0 en
          {' '}
          <a
            href="https://www.plataformadetransparencia.org.mx/Inicio"
            target="_blank"
            rel="noreferrer"
          >
            https://www.plataformadetransparencia.org.mx/Inicio
          </a>
        </Text>
      </li>
    </ul>
    <br />
    <br />
    <Text>
      Dicha solicitud deberá contener:
    </Text>
    <br />
    <br />
    <ul>
      <li>
        <Text>
          Los datos de identificación que acrediten que el solicitante es el titular de los datos
          personalessobre los que se ejerce la solicitud, así como copia de su identificación
          oficial y, en su caso, la de su representante;
        </Text>
      </li>
      <li>
        <Text>
          Dirigida al Lic. José Manuel Lagarda Bórquez, Titular de la Unidad de Transparencia del
          H. Ayuntamiento de Navojoa
        </Text>
      </li>
      <li>
        <Text>
          La descripción clara y precisa de los datos personales respecto de los que se busca
          ejercer alguno de los derechos antes mencionados(Acceso, Rectificación, Cancelación u
          Oposición).
        </Text>
      </li>
      <li>
        <Text>
          Cualquier otro elemento que facilite la localización de la información; y Opcionalmente,
          la modalidad en la que prefiere se otorgue el acceso a sus datos
          personales, la cual podrá ser verbalmente, mediante consulta directa, copias simples,
          certificadas u otro tipo de medio. Cabe señalar que el interesado deberá cubrir los
          costos de reproducción de los datos solicitados, de acuerdo a lo establecido en la
          respectiva Ley deIngresos.
        </Text>
      </li>
      <li>
        <Text>
          En el caso de solicitudes de rectificación de datos personales, ésta deberá indicar
          además de los requisitos arriba señalados, las modificaciones que deban realizarse, así
          como la documentación que sustente la solicitud.
        </Text>
      </li>
      <li>
        <Text>
          Tratándose de solicitudes de cancelación, la solicitud deberá indicar si revoca el
          consentimiento otorgado en los casos en que la revocación proceda, o si la cancelación
          deriva de la existencia de un dato erróneo o inexacto, en cuyo caso deberá acompañar
          la documentación justificativa.
        </Text>
      </li>
    </ul>
    <br />
    <br />
    <Text>
      Cualquier cambio al presente aviso de confidencialidad se hará del conocimiento de
      lostitulares de la información confidencial, a través de la página de internet de este
      sujeto obligado, la cual es:
      {' '}
      <a
        href="https://www.navojoa.gob.mx"
        target="_blank"
        rel="noreferrer"
      >
        www.navojoa.gob.mx
      </a>
    </Text>
  </Card>
);

export default PrivacyNoticeNavojoa;
